exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".collection-privacy-status{display:flex;text-transform:none}.collection-privacy-status__text{color:#fa6422;margin-left:2px}@media (max-width: 479px){.collection-privacy-status--compact .collection-privacy-status__text{display:none}}\n", ""]);

// exports
exports.locals = {
	"collection-privacy-status": "collection-privacy-status",
	"collection-privacy-status__text": "collection-privacy-status__text",
	"collection-privacy-status--compact": "collection-privacy-status--compact"
};